import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

function FlashDelivery() {
  return (
    <>
      <Header />
      
      <section className="flash-delivery-section">
        <div className="container">
          <div className="flash-delivery-hero">
            <h1 className="flash-delivery-title">
              <span className="title-line-1">Flash Delivery</span><br/>
              <span className="title-line-2">Projects</span>
            </h1>
            <p className="flash-delivery-subtitle">Explore my design work for Flash Delivery</p>
          </div>

          <div className="flash-delivery-grid">
            <div className="flash-project-card">
              <div className="image-wrapper">
                <img src="/assets/flash-delivery-first.png" alt="Flash Delivery Homepage Redesign" />
                <div className="image-overlay">Case Study</div>
              </div>
              <div className="flash-project-content">
                <h3 className="flash-project-title">Flash Delivery – Homepage Redesign Case Study</h3>
                <p className="flash-project-desc">Redesigning the homepage to improve clarity, speed, and conversion</p>
                
                <div className="flash-project-stats">
                  <div className="flash-stat-item">
                    <div className="flash-stat-label">Role</div>
                    <div className="flash-stat-value">UI/UX</div>
                  </div>
                  <div className="flash-stat-item">
                    <div className="flash-stat-label">Year</div>
                    <div className="flash-stat-value">2024</div>
                  </div>
                  <div className="flash-stat-item">
                    <div className="flash-stat-label">Platform</div>
                    <div className="flash-stat-value">Web</div>
                  </div>
                </div>
                
                <a href="/projects/flash-delivery/homepage" className="btn">View Project <span className="btn-arrow">→</span></a>
              </div>
            </div>

            <div className="flash-project-card">
              <div className="image-wrapper">
                <img src="https://images.unsplash.com/photo-1566576721346-d4a3b4eaeb55?w=800&h=600&fit=crop" alt="Flash Delivery Mobile App" />
                <div className="image-overlay">Mobile App</div>
              </div>
              <div className="flash-project-content">
                <h3 className="flash-project-title">Flash Delivery – Mobile App Design</h3>
                <p className="flash-project-desc">Creating a seamless mobile experience for on-the-go delivery tracking and ordering</p>
                
                <div className="flash-project-stats">
                  <div className="flash-stat-item">
                    <div className="flash-stat-label">Role</div>
                    <div className="flash-stat-value">UI/UX</div>
                  </div>
                  <div className="flash-stat-item">
                    <div className="flash-stat-label">Year</div>
                    <div className="flash-stat-value">2024</div>
                  </div>
                  <div className="flash-stat-item">
                    <div className="flash-stat-label">Platform</div>
                    <div className="flash-stat-value">Mobile</div>
                  </div>
                </div>
                
                <a href="/projects/flash-delivery/mobile" className="btn">View Project <span className="btn-arrow">→</span></a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default FlashDelivery;
